/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {withDLSTheme} from '../../theme/withDLSTheme';
import {RadioButton as CurrentRadioButton} from './current/RadioButton';
import {RadioButton as LegacyRadioButton} from './legacy/RadioButton';

// This is essential if a client imports the `RadioButton` component using
// `import {RadioButton} from ‘./RadioButton’;`
export const RadioButton = withDLSTheme(LegacyRadioButton, CurrentRadioButton);

export default RadioButton;
